import Axios from "axios"
import api from "../../api"
import { errorHandler, generateRequestHeaders } from "../../utils";

const deleteFile = async (id) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: generateRequestHeaders()
    }

    Axios.delete(`${api.base}${api.resources_file}${id}/`, config)
      .then(res => {
        console.log(res)
        if(res.data){
          resolve(res.data)
        }else{
          resolve(res)
        }
      })
      .catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
  })
}

export {
  deleteFile
}
